module.exports = __webpack_public_path__ + "img/CC-Brown.a82b4698.png";